// extracted by mini-css-extract-plugin
module.exports = {"logo":"blue__logo--11JCC"};
    if(module.hot) {
      // 1546575112261
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  